export default __webpack_public_path__ + "static/sponsors-app-76a5b040745ecd58d6a8fdd16cb0b9e6.png";